// TennisTrack Hub — Recupera Password | 029 Project
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const RecuperaPassword = () => {
  const [email, setEmail] = useState('');
  const [stato, setStato] = useState(''); // '' | 'success' | 'error'
  const [messaggio, setMessaggio] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStato('');
    try {
      const res = await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setStato('success');
      setMessaggio(res.data.message);
    } catch (err) {
      setStato('error');
      setMessaggio(err.response?.data?.error || 'Errore durante la richiesta.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">

        <div className="auth-logo">
          <img src="/img/logo_tennistrack_300x800.png" alt="TennisTrack Hub" />
        </div>

        <div className="card auth-card">
          <h2 className="auth-title">Recupera Password</h2>
          <p className="auth-subtitle">Inserisci la tua email per ricevere le istruzioni</p>

          {stato === 'success' && (
            <div className="alert alert-success">{messaggio}</div>
          )}
          {stato === 'error' && (
            <div className="alert alert-error">{messaggio}</div>
          )}

          {stato !== 'success' && (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="tuaemail@esempio.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-full"
                disabled={loading}
              >
                {loading ? 'Invio in corso...' : 'Invia istruzioni'}
              </button>
            </form>
          )}

          <div className="auth-switch">
            <Link to="/login">← Torna al login</Link>
          </div>
        </div>

        <div className="auth-footer">
          <img src="/img/madeby029.png" alt="029 Project" className="footer-logo" />
        </div>

      </div>
    </div>
  );
};

export default RecuperaPassword;
